(function () {
    function initTimer(el) {
      if (el._bsTimerInited) return;
      el._bsTimerInited = true;
  
      // Read config from data attributes (set in Liquid snippet)
      var saleEnd   = new Date(el.dataset.saleEnd);
      var buzzFrom  = el.dataset.buzzFrom;   // 'YYYY-MM-DD'
      var buzzTo    = el.dataset.buzzTo;     // 'YYYY-MM-DD'
      var buzzSh    = parseInt(el.dataset.buzzSh, 10);  // start hour (20)
      var buzzSm    = parseInt(el.dataset.buzzSm, 10);  // start min  (0)
      var buzzEh    = parseInt(el.dataset.buzzEh, 10);  // end hour   (21)
      var buzzEm    = parseInt(el.dataset.buzzEm, 10);  // end min    (20)
  
      var labelEl = el.querySelector('.bs-timer__label');
      var dotEl   = el.querySelector('.bs-timer__dot');
      var subEl   = el.querySelector('.bs-timer__sub');
      var daysEl  = el.querySelector('[id^="bs-timer-days"]');
      var hrsEl   = el.querySelector('[id^="bs-timer-hrs"]');
      var minEl   = el.querySelector('[id^="bs-timer-min"]');
      var secEl   = el.querySelector('[id^="bs-timer-sec"]');
  
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
  
      // Get IST date string 'YYYY-MM-DD' for a given JS Date
      function istDateStr(date) {
        var ist = new Date(date.getTime() + (5.5 * 3600000));
        return ist.toISOString().slice(0, 10);
      }
  
      // Check if now is inside the buzz window for today
      function getBuzzTarget() {
        var now     = new Date();
        var today   = istDateStr(now);
  
        if (today < buzzFrom || today > buzzTo) return null;
  
        // Build today's buzz start/end in IST
        var startStr = today + 'T' + pad(buzzSh) + ':' + pad(buzzSm) + ':00+05:30';
        var endStr   = today + 'T' + pad(buzzEh) + ':' + pad(buzzEm) + ':00+05:30';
        var start    = new Date(startStr);
        var end      = new Date(endStr);
  
        if (now >= start && now < end) return end;
        return null;
      }
  
      var _lastMode = null;
  
      function tick() {
        var now        = new Date();
        var buzzTarget = getBuzzTarget();
        var target, mode;
  
        if (buzzTarget) {
          target = buzzTarget;
          mode   = 'buzz';
        } else {
          target = saleEnd;
          mode   = 'sale';
        }
  
        // Update label only on mode switch (avoid DOM thrash every second)
        if (mode !== _lastMode) {
          if (mode === 'buzz') {
            labelEl.textContent      = 'Buzz Offer Ends';
            labelEl.style.color      = '#ff9c1c';
            dotEl.style.background   = '#ff9c1c';
            subEl.textContent        = 'Extra ₹80 off — Hurry!';
          } else {
            labelEl.textContent      = 'Sale Ends In';
            labelEl.style.color      = '#de1612';
            dotEl.style.background   = '#de1612';
            subEl.textContent        = "Don't miss out";
          }
          _lastMode = mode;
        }
  
        var diff = Math.max(0, target - now);
        var days = Math.floor(diff / 86400000);
        var hrs  = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000)  / 60000);
        var secs = Math.floor((diff % 60000)    / 1000);
  
        daysEl.textContent = pad(days);
        hrsEl.textContent  = pad(hrs);
        minEl.textContent  = pad(mins);
        secEl.textContent  = pad(secs);
  
        if (diff > 0) setTimeout(tick, 1000);
      }
  
      tick();
    }
  
    function scanForTimers() {
      document.querySelectorAll('.bs-timer').forEach(initTimer);
    }
  
    scanForTimers();
    new MutationObserver(scanForTimers).observe(document.body, { childList: true, subtree: true });
  })();


  // ── Cart Buzz Timer ──────────────────────────────────────────────────────────
(function () {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
  
    function istDateStr(date) {
      var ist = new Date(date.getTime() + (5.5 * 3600000));
      return ist.toISOString().slice(0, 10);
    }
  
    function tick() {
      var el = document.getElementById('bs-cart-buzz');
      if (!el) { setTimeout(tick, 1000); return; }
  
      var buzzFrom = el.dataset.buzzFrom;
      var buzzTo   = el.dataset.buzzTo;
      var buzzSh   = parseInt(el.dataset.buzzSh, 10);
      var buzzSm   = parseInt(el.dataset.buzzSm, 10);
      var buzzEh   = parseInt(el.dataset.buzzEh, 10);
      var buzzEm   = parseInt(el.dataset.buzzEm, 10);
  
      var now   = new Date();
      var today = istDateStr(now);
  
      if (today < buzzFrom || today > buzzTo) {
        el.style.display = 'none';
        setTimeout(tick, 5000);
        return;
      }
  
      var start = new Date(today + 'T' + pad(buzzSh) + ':' + pad(buzzSm) + ':00+05:30');
      var end   = new Date(today + 'T' + pad(buzzEh) + ':' + pad(buzzEm) + ':00+05:30');
  
      if (now < start || now >= end) {
        el.style.display = 'none';
        setTimeout(tick, 5000);
        return;
      }
  
      el.style.display = 'flex';
  
      var minEl = document.getElementById('bs-cart-buzz-min');
      var secEl = document.getElementById('bs-cart-buzz-sec');
      var diff  = Math.max(0, end - now);
      if (minEl) minEl.textContent = pad(Math.floor(diff / 60000));
      if (secEl) secEl.textContent = pad(Math.floor((diff % 60000) / 1000));
  
      if (diff > 0) {
        setTimeout(tick, 1000);
      } else {
        el.style.display = 'none';
      }
    }
  
    tick(); // deferred script hai — DOM already ready hai, direct call safe hai
  })();